export const strategyStore = {
  namespaced: true,
  state: {
    objid: -1,
    base: {}, // 基本信息
    havePageChanges: false,
    secondaryControl: { // 二级控制
      'open_force_filter_rule': true, // '是否开启强制排除店仓规则',
      'open_sourcing_rule': true, // '是否开启寻源规则',
      'open_warehouse_rule': false, // '是否开启仓优先规则',
      'open_score_rule': false, // '是否开启评分策略',
      'open_batch_rule': false, // '是否开启指定仓库批次',
      'open_min_split_rule': false, // '是否开启最小拆包数',
    },
    logicalLevel: {},
    logicalLevel1: {},
    allOptions1: {},
    allOptions: {}
  },
  mutations: {
    mu_havePageChanges(state, n) {
      state.havePageChanges = n;
    },
    mu_logicalLevel1(state, n) {
      let obj = _.cloneDeep(state.logicalLevel1)
      let keys = Object.keys(n);
      keys.forEach((k) => obj[k] = n[k]);
      state.logicalLevel1 = obj;
    },
    mu_logicalLevel(state, n) {
      let obj = _.cloneDeep(state.logicalLevel)
      let keys = Object.keys(n);
      keys.forEach((k) => obj[k] = n[k]);
      state.logicalLevel = obj;
    },
    mu_base(state, n) {
      state.base = n;
    },
    changeControl(state, n) {
      console.log('mutations::changeControl::', n);
      let obj = _.cloneDeep(state.secondaryControl)
      let keys = Object.keys(n);
      keys.forEach((k) => obj[k] = n[k]);
      state.secondaryControl = obj;
    },
    mu_allOptions1(state, n) {
      console.log('mutations::mu_allOptions1::', n);
      state.allOptions1 = n;
    },
    mu_allOptions(state, n) {
      console.log('mutations::mu_allOptions::', n);
      state.allOptions = n;
    },
    mu_objid(state, n) {
      state.objid = n;
    },
  },
  actions: {
    allClose({ state, commit }, n) {
      // const before = _.cloneDeep(state.secondaryControl)
      const after = _.cloneDeep(state.secondaryControl)
      const current = n.current
      delete n.current
      console.log('actions::allClose::', n, current);
      let keys = Object.keys(n);
      keys.forEach((k) => after[k] = n[k]);
      const after_values = Object.values(after)
      if (after_values.every(i => i === false)) {
        vm.$Message.warning('至少开启一项寻源策略！');
        commit('changeControl', { [current]: true })
        return
      }
      commit('changeControl', n)
      commit('mu_havePageChanges', true)
    },
  }
};
export default strategyStore;
